import * as api from '../../api/index'
import * as endpoints from '../../api/endpoints'
import * as types from "../../mutation-types";
import {SET_SC_WORK_COLLECTOR} from "../../mutation-types";

const actions = {
  getSCWorks({commit}, payload) {
    return api.fetch(endpoints.SC_WORK, payload, commit,(response) => {
      commit(types.SET_SC_WORKS, response.data.data);
      commit("common/"+types.SET_PAGINATION, response.data.pagination, { root: true });
    });
  },
  getSCWork({commit}, payload) {
    return api.fetch(endpoints.SC_WORK+'/'+payload.uuid, payload, commit,(response) => {
      commit(types.SET_SC_WORK, response.data);
    });
  },
  createSCWork({commit}, payload) {
    return api.post(endpoints.SC_WORK, payload, commit, (response) => {
      commit(types.SET_SC_WORK, response.data);
    });
  },
  updateSCWork({commit}, payload) {
    return api.put(endpoints.SC_WORK+'/'+payload.uuid, payload, commit, (response) => {
      commit(types.UPDATE_SC_WORK_ITEM, response.data);
    });
  },
  deleteSCWork({commit}, payload) {
    return api.remove(endpoints.SC_WORK+'/'+payload.uuid, payload, commit, (response) => {
      commit(types.DELETE_SC_WORK_ITEM, response.data);
    });
  },
  getSCWorkCollector({commit}, payload) {
    return api.fetch(endpoints.SC_WORK_COLLECTOR, payload, commit,(response) => {
      commit(types.SET_SC_WORK_COLLECTOR, response.data.data);
      commit("common/"+types.SET_PAGINATION, response.data.pagination, { root: true });
    });
  },
}

export default actions;
